import _ from 'lodash';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
const $ = require('jquery');
import 'jquery-ui';
// import IMask from 'imask';
import { gsap } from "gsap";
import { setupProgressBar, addPrevNextBtnsClickHandlers } from './js/shared/EmblaCarousel';

import "./styles.scss";

import "./js/shared/formHandling";
import "./js/shared/pageComponents";
import "./js/shared/loadAssets";
import "./js/shared/cookies";
import "./js/shared/formOptionAB";
import "./js/pages/header";
import "./js/pages/frontPage";
import "./js/pages/instantRates";
import "./js/pages/dOneComponents";
// import "./js/landing-pages/landingPageForm";
import "./js/jquery/theme";

const emblaNode = document.querySelector(".embla");
if (emblaNode) {
    import("./js/shared/EmblaCarousel")
        .then(({ default: initializeEmbla }) => initializeEmbla())
        .catch(error => console.error("Failed to load Embla Carousel:", error));
}

const chatContainer = document.getElementById("chat-container");
if (chatContainer) {
    import("./js/chatbot/chatbotLoader")
        .then(({ default: initializeChatbot }) => initializeChatbot())
        .catch(error => console.error("Failed to load Chatbot:", error));
}